import { ApiService } from '../apiService'

export const getSiteTaskGroups = (projectId = null) => {
  const path = projectId ? `/projects/${projectId}/site_task_groups` : '/site_task_groups'
  return ApiService.get(path)
}

export const createSiteTaskGroup = (siteTaskGroup) => {
  return ApiService.post(`/projects/${siteTaskGroup.project_id}/site_task_groups`, { site_task_group: siteTaskGroup })
}

export const updateSiteTaskGroup = (id, siteTaskGroup) => {
  return ApiService.patch(`/site_task_groups/${id}`, { site_task_group: siteTaskGroup })
}

export const deleteSiteTaskGroup = (id) => {
  return ApiService.destroy(`/site_task_groups/${id}`, {})
}
